import { Col, Container, Row } from 'react-bootstrap'
import React from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { Contacts } from './Contacts'
import { useGetExternalUsersQuery } from '../../store/externalUser/externalUser'

export const ManageContacts: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)

  const { data: users } = useGetExternalUsersQuery({ accountId, pageRequest: { page: 0, size: 50 } }, { refetchOnMountOrArgChange: true })

  return (
    <Container fluid>
      <Row className='mb-8'>
        <Col className='p-0'>
          <Container>
            <Row>
              <Col>
                <Row>
                  <Col>
                    <h3>Contacts</h3>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className='paragraph-medium zocks-text-gray-600'>{users?.page.totalElements} contacts</div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <Row>
        <Col>
          <Contacts />
        </Col>
      </Row>
    </Container>
  )
}
